interface MentorshipToolProps {
  toolName: string;
  args: any;
  result?: string;
  status?: "running" | "complete" | "error";
}

export function MentorshipTool({
  toolName: _toolName,
  args,
  result,
  status,
}: MentorshipToolProps) {
  // Parse the result if available
  let parsedResult: any = null;
  if (result) {
    try {
      parsedResult = JSON.parse(result);
    } catch (e) {
      console.warn("Failed to parse mentorship result:", result);
    }
  }

  return (
    <div className="text-sm">
      {/* Show parameters as simple text */}
      {args && Object.keys(args).length > 0 && (
        <div className="space-y-1 text-gray-500">
          {Object.entries(args).map(([key, value]) => (
            <div key={key}>
              {key.replace(/_/g, " ")}: {String(value)}
            </div>
          ))}
        </div>
      )}

      {/* Show structured results when complete */}
      {parsedResult && status === "complete" && (
        <div className="mt-3">
          {Array.isArray(parsedResult) ? (
            <div>
              <div className="mb-2 text-sm text-gray-600">
                Found {parsedResult.length} total mentorships
              </div>

              <div className="space-y-2">
                {parsedResult
                  .slice(0, 4)
                  .map((mentorship: any, index: number) => (
                    <div
                      key={mentorship.id || index}
                      className="rounded bg-gray-50 p-2 text-sm"
                    >
                      <div className="font-medium text-gray-900">
                        {mentorship.teen_name || mentorship.mentee_name}
                      </div>
                      <div className="text-xs text-gray-600">
                        Started{" "}
                        {mentorship.created_at
                          ? new Date(mentorship.created_at).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              },
                            )
                          : "N/A"}
                      </div>
                    </div>
                  ))}
              </div>

              {parsedResult.length > 4 && (
                <div className="mt-2 text-sm text-gray-500">
                  +{parsedResult.length - 4} more mentorships
                </div>
              )}
            </div>
          ) : parsedResult.mentorship ? (
            // Single mentorship details
            <div className="rounded-lg bg-gray-50 p-3">
              <div className="mb-1 font-medium text-gray-900">
                {parsedResult.mentorship.teen_name} ↔{" "}
                {parsedResult.mentorship.mentor_name}
              </div>
              <div className="space-y-1 text-sm text-gray-600">
                <div>
                  Status:{" "}
                  <span className="capitalize">
                    {parsedResult.mentorship.status}
                  </span>
                </div>
                {parsedResult.mentorship.created_at && (
                  <div>
                    Started:{" "}
                    {new Date(
                      parsedResult.mentorship.created_at,
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="text-sm text-gray-600">
              Mentorship data processed successfully
            </div>
          )}
        </div>
      )}
    </div>
  );
}
